<template>
  <main>
    <!-- <h6 class="mt-4">{{ $t("lang.label.target") }}</h6> -->
    <LoadingSpinner v-if="!completeLoading" />
    <div v-else>
      <div class="row border-bottom border-grey bg-light pt-3 mb-5">
        <div class="col-sm-12 d-flex p-0">
              <div class="pb-2 d-inline">
                <Tabs
                  :tabs="tabs"
                  @change="changeTab($event)"
                  :tabSelected="tabSelected"
                />
              </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped">
            <thead class="thead-dark">
              <td width="50px"></td>
              <td>Workspace</td>

              <td v-if="tabSelected == 0">Type</td>
              <td>Email</td>
            </thead>
            <tbody>
              <tr v-for="(row, index) in list" :key="index">
                <td>
                  {{ index + 1 }}
                </td>

                <td>
                  {{ row.workspace }}
                </td>
                <td v-if="tabSelected == 0">
                  {{ row.sync_type }}
                </td>
                <td>
                  <span class="mr-2"> {{ row.nylas_email_sync }}</span>
                  <span
                    v-if="row.nylas_email_sync_status == 1"
                    @click="openEmails(row.id, 100, 0)"
                    class="badge-success badge text-white cursor-pointer"
                    ><i class="icon-mail mr-1"></i>Synced</span
                  >
                  <span
                    v-if="row.nylas_email_sync_status == 0 && tabSelected !== 4"
                    @click="connect(row)"
                    class="badge btn-danger cursor-pointer"
                  >
                    <i class="icon-arrow-circle-o-right mr-1"></i> Sync now
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
import { adminService, usersService } from "@/_services";

export default {
  data() {
    return {
      list: [],
      completeLoading: false,
      tabs: {
        0: {
          id: 0,
          name: this.$t("lang.integrations.unsync"),
        },
        1: {
          id: 1,
          name: this.$t("lang.integrations.sync"),
        },
        4: {
          id: 4,
          name: this.$t("lang.campaigns_dashboard.waiting"),
        },
      },
      tabSelected: 1,
    };
  },
  components: { LoadingSpinner,Tabs },
  computed: {},
  created() {
    this.getEmailSyncList();
  },
  methods: {
    getEmailSyncList() {
      this.completeLoading = false;
      adminService.getEmailSyncList(this.tabSelected).then(
        (result) => {
          this.list = result;
          this.completeLoading = true;
        },
        (error) => {
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );
    },

    changeTab(index) {
      this.tabSelected = this.tabs[index].id;
      this.getEmailSyncList()
    },

    connect(user) {
      usersService
        .getAuthenticationUrl(
          user.nylas_email_sync,
          user.name,
          user.lastname,
          user.id
        )
        .then(
          (result) => {
            window.open(result, "_blank");
          },
          (error) => {
            this.$store.dispatch("alert/error", error, { root: true });
          }
        );
    },
  },
};
</script>